import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RecaptchaWrapper = ({ onVerify, onExpired, onError, disabled = false }) => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  
  if (!siteKey) {
    console.warn('reCAPTCHA site key not found');
    return null;
  }
  
  return (
    <div className="flex justify-center mb-4">
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={onVerify}
        onExpired={onExpired}
        onError={onError}
        size="normal"
        theme="light"
        disabled={disabled}
      />
    </div>
  );
};

export default RecaptchaWrapper;